import { css } from 'styled-system/css';

export const bookingInputStyle = {
	input: css({
		_mars: {
			bgColor: 'white.2',
		}
	}),
	controlButton: css({
		_mars: {
			bgColor: 'booked.2',
			_disabled: {
				bgColor: 'booked.2_30',
				color: 'whiteOpacity.100',
				_hover: {
					bgColor: 'booked.2_30',
				}
			},
			lg: {
				_hover: {
					bgColor: 'booked.3',
				}
			}
		}
	}),
}